<template>
  <div class="content">
    <div class="header">
      <img src="@/assets/img/name.png" style="margin-top: 15px" />
    </div>
    <div>
      <div style="border-bottom: 1px solid #666; margin-bottom: 20px">
        <div class="search">
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col
              :span="5"
              style="
                line-height: 40px;
                text-align: right;
                font-weight: 600;
                color: #777;
              "
              >站内搜索：</el-col
            >
            <el-col :span="15">
              <el-input
                class="searchEl"
                placeholder="请输入关键词"
                @change="search"
                v-model="searchKey"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="search(searchKey)" round
                >搜索</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div style="padding: 5px 10px; background: #f9f9f9; font-size: 14px">
          为您找到相关结果{{ list.totalCount }}个
        </div>
      </div>
    </div>
    <div style="width: 800px">
      <div class="list">
        <ul>
          <li
            v-for="(item, index) in list.result"
            :key="index"
            @click="openNew(item)"
            style="cursor: pointer"
          >
            <div class="item">
              <a style="text-decoration: underline">{{ item.title }}</a>
              <div
                class="beyondEllipsis3 contentTxt"
                style="
                  width: 600px;
                  font-size: 14px;
                  margin-top: 10px;
                  max-height: 58px;
                "
              >
                {{ item.content }}
              </div>
              <div style="color: #008000; font-size: 13px; line-height: 30px">
                <span>作者：{{ item.userName }}</span>
                <span style="padding-left: 20px"
                  >发布时间：{{ item.createDate.slice(0, 10) }}</span
                >
              </div>
            </div>
          </li>
        </ul>
      </div>
      <el-pagination
        background
        style="text-align: left; background: #fff"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="list.totalCount"
      ></el-pagination>
    </div>
    <login-view ref="loginView" :cancel="false" />
  </div>
</template>

<script>
import loginView from "@/components/loginView";
import { noticeQy, login } from "@/api/home";
export default {
  data() {
    return {
      searchKey: "",
      pageNo: 1,
      pageSize: 20,
      list: {
        result: [],
      },
      retrieveArg: "",
    };
  },
  components: {
    loginView,
  },
  mounted() {
    this.searchKey = this.$route.query.wd;
    this.retrieveArg = this.searchKey;
    this.getList();
  },
  methods: {
    openNew(item) {
      if (item.businessTypeCode == "GENERALRESOURCE") {
        login({ op: "getSessionUser" })
          .then((response) => {
            if (!response) {
              this.$refs.loginView.show();
            } else {
              this.goPage(item);
            }
          })
          .catch((error) => {});
      } else {
        this.goPage(item);
      }
    },
    goPage(item) {
      window.open(
        "#/" + item.detailPageUrl + "&id=-1&pageViewId=" + item.pageViewId,
        "_blank"
      );
    },
    search(val) {
      this.pageNo = 1;
      this.pageSize = 20;
      this.list = {
        result: [],
      };
      this.retrieveArg = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = val;
      this.getList();
    },
    getList() {
      noticeQy({
        op: "findPageGlobal",
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        retrieveArg: this.retrieveArg,
      }).then((res) => {
        this.list = res;
        this.list.result.map((res) => {
          let objE = document.createElement("div");
          objE.innerHTML = res.content;
          res.content = objE.innerText;
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 70px;
  background: #fff;
  box-shadow: 0 2px 5px 2px #ddd;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1;
  left: 0;
}
.search {
  width: 1000px;
}
.content {
  padding: 100px 30px;
  .item {
    margin-bottom: 10px;
    .contentTxt {
      color: #999;
    }
    &:hover {
      .contentTxt {
        color: #666;
      }
    }
  }
}
</style>